//jacques-andre-editeur\proshop-v2\frontend\src\screens\admin\AuthorEditScreen.jsx
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Button, Container } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';
import { 
  useGetAuthorDetailsByIdQuery,
  useUpdateAuthorMutation,
} from '../../slices/authorsApiSlice';

const AuthorEditScreen = () => {

  const { id: authorId } = useParams();

  const [firstName, setFirstName] = useState('');;
  const [lastName, setLastName] = useState('');
  const [realFirstName, setRealFirstName] = useState('');
  const [realLastName, setRealLastName] = useState('');
  const [bio, setBio] = useState('');
  const [biblio, setBiblio] = useState('');
  const [photo, setPhoto] = useState('');
  const [website, setWebsite] = useState('');
  const [facebook, setFacebook] = useState('');
  const [instagram, setInstagram] = useState('');
  const [twitter, setTwitter] = useState('');
  const [linkedIn, setLinkedIn] = useState('');
  const [wikipedia, setWikipedia] = useState('');
  const [youtube, setYoutube] = useState('');
  const [isVisible, setIsVisible] = useState(true);
  const [inList, setInList] = useState(true);

  const { data: author } = useGetAuthorDetailsByIdQuery({
    authorId,
    isAdminSpace: true,
  });

  useEffect(() => {
    if (author) {
      setFirstName(author.firstName);
      setLastName(author.lastName);
      setRealFirstName(author.realFirstName);
      setRealLastName(author.realLastName);
      setBio(author.bio);
      setBiblio(author.biblio);
      setPhoto(author.photo);
      setWebsite(author.website || '');
      setFacebook(author.facebook || '');
      setInstagram(author.instagram || '');
      setTwitter(author.twitter || '');
      setLinkedIn(author.linkedIn || '');
      setWikipedia(author.wikipedia || '');
      setYoutube(author.youtube || '');
      setIsVisible(author.isVisible);
      setInList(author.inList);
    }
  }, [author]);


  const navigate = useNavigate();

  const [updateAuthor, { isLoading: loadingUpdate }] = useUpdateAuthorMutation();
 
  const submitHandler = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('authorId', authorId);
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('realFirstName', realFirstName);
    formData.append('realLastName', realLastName);
    formData.append('bio', bio);
    formData.append('biblio', biblio);
    formData.append('website', website);
    formData.append('facebook', facebook);
    formData.append('instagram', instagram);
    formData.append('twitter', twitter);
    formData.append('linkedIn', linkedIn);
    formData.append('wikipedia', wikipedia);
    formData.append('youtube', youtube);
    formData.append('isVisible', isVisible);
    formData.append('inList', inList);
    
    // Ajouter l'image si elle existe
    if (photo instanceof FormData) {
      formData.append('photo', photo.get('photo'));
    }

    // Inspecter le contenu du FormData
    console.log('FormData contenu :');
    for (const [key, value] of formData.entries()) {
      console.log(`${key}:`, value, '!!');
    }

    try {
      await updateAuthor(formData).unwrap();
      toast.success('Auteur modifié avec succès');
      navigate('/admin/authorlist');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <Container>
      <FormContainer>
        <div className="h1-adminContainer">
          <h1>Modifier la fiche d'un auteur</h1>
        </div>
        {loadingUpdate && <Loader />}
        <Form onSubmit={submitHandler}>
          <Form.Group controlId='firstName'>
            <Form.Label>Prénom d'auteur</Form.Label>
            <Form.Control
              type='text'
              placeholder='Saisir le prénom'
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='lastName'>
            <Form.Label>Nom d'auteur (ou pseudo) *</Form.Label>
            <Form.Control
              type='text'
              placeholder='Saisir le nom'
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='realFirstName'>
          <Form.Label>Prénom civil (si autre que prénom d'auteur)</Form.Label>
              <Form.Control
                type='text'
                placeholder='Saisir le vrai prénom'
                value={realFirstName}
                onChange={(e) => setRealFirstName(e.target.value)}
              ></Form.Control>
          </Form.Group>

          <Form.Group controlId='realLastName'>
          <Form.Label>Nom civil (si autre que prénom d'auteur)</Form.Label>
              <Form.Control
                type='text'
                placeholder='Saisir le vrai nom'
                value={realLastName}
                onChange={(e) => setRealLastName(e.target.value)} />
          </Form.Group>
          
          <Form.Group controlId="photo">
            <Form.Label>Photo</Form.Label>
            <Form.Control
              type="text"
              placeholder="URL actuelle de la photo"
              value={photo}
              disabled
            ></Form.Control>
            <Form.Control
              type="file"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  const formData = new FormData();
                  formData.append('photo', file);
                  setPhoto(formData);
                }
              }}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='bio'>
            <Form.Label>Biographie</Form.Label>
            <ReactQuill value={bio} onChange={setBio} />
          </Form.Group>

          <Form.Group controlId='biblio'>
            <Form.Label>Bibliographie</Form.Label>
            <ReactQuill value={biblio} onChange={setBiblio} />
          </Form.Group>

          <Form.Group controlId='website'>
            <Form.Label>Site Web</Form.Label>
            <Form.Control
              type='text'
              placeholder='Saisir une URL de site web'
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <h3>Réseaux sociaux</h3>
          <Form.Group controlId='facebook'>
            <Form.Label>Facebook</Form.Label>
            <Form.Control
              type='text'
              placeholder='URL du profil Facebook'
              value={facebook}
              onChange={(e) => setFacebook(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='instagram'>
            <Form.Label>Instagram</Form.Label>
            <Form.Control
              type='text'
              placeholder='URL du profil Instagram'
              value={instagram}
              onChange={(e) => setInstagram(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='twitter'>
            <Form.Label>Twitter</Form.Label>
            <Form.Control
              type='text'
              placeholder='URL du profil Twitter'
              value={twitter}
              onChange={(e) => setTwitter(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='linkedIn'>
            <Form.Label>LinkedIn</Form.Label>
            <Form.Control
              type='text'
              placeholder='URL du profil LinkedIn'
              value={linkedIn}
              onChange={(e) => setLinkedIn(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='wikipedia'>
            <Form.Label>Wikipedia</Form.Label>
            <Form.Control
              type='text'
              placeholder='URL de la page Wikipedia'
              value={wikipedia}
              onChange={(e) => setWikipedia(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='youtube'>
            <Form.Label>Youtube</Form.Label>
            <Form.Control
              type='text'
              placeholder='URL de la chaîne Youtube'
              value={youtube}
              onChange={(e) => setYoutube(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='isVisible'>
            <Form.Label>Visibilité</Form.Label>
            <Form.Check
              type='checkbox'
              label='Visible'
              checked={isVisible}
              onChange={(e) => setIsVisible(e.target.checked)}
            ></Form.Check>
            <Form.Check
              type='checkbox'
              label='Présent dans la liste'
              checked={inList}
              onChange={(e) => setInList(e.target.checked)}
            ></Form.Check>
          </Form.Group>

          <Button type='submit' variant='primary' style={{ marginTop: '1rem' }}>
            Ajouter
          </Button>
        </Form>
      </FormContainer>
    </Container>
  );
};

export default AuthorEditScreen;
